/* =========================================================
   LOVEA PARIS — thème Shopify — theme.js
   Panier (AJAX Cart API Shopify), menu mobile, guide des
   tailles en popup, liste de souhaits (tiroir + localStorage),
   pastilles couleur cliquables, carrousel vidéo, retour
   en haut. Le paiement et le multilingue/multi-devise passent
   par les mécanismes natifs Shopify (checkout, localization).
   ========================================================= */
(function () {
  "use strict";
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  document.addEventListener("DOMContentLoaded", () => {
    initMobileNav();
    initBackTop();
    initCartDrawer();
    initSizeGuideModal();
    initWishlist();
    initWishlistDrawer();
    initCardColorSwatches();
    initVideoCarousel();
    initSearchOverlay();
    initAccordions();
    initUnitToggles();
    initNewsletterForm();
    initProductForm();
    initLocaleSelectors();
  });

  /* ---------------- Sélecteurs langue / devise (formulaires natifs Shopify) ---------------- */
  function initLocaleSelectors() {
    $$("[data-locale-disclosure]").forEach((disclosure) => {
      const toggle = $("[data-locale-toggle]", disclosure);
      const list = $("[data-locale-list]", disclosure);
      toggle?.addEventListener("click", (e) => {
        e.stopPropagation();
        const isOpen = !list.hasAttribute("hidden");
        $$("[data-locale-list]").forEach((l) => l.setAttribute("hidden", ""));
        if (!isOpen) list.removeAttribute("hidden");
      });
    });
    document.addEventListener("click", () => { $$("[data-locale-list]").forEach((l) => l.setAttribute("hidden", "")); });

    $$("[data-locale-value]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const form = btn.closest("form");
        const inputName = btn.getAttribute("data-locale-input");
        const input = form.querySelector(`input[name="${inputName}"]`);
        if (input) input.value = btn.getAttribute("data-locale-value");
        form.submit();
      });
    });
  }

  /* ---------------- Menu mobile ---------------- */
  function initMobileNav() {
    const nav = $("#mobileNav");
    if (!nav) return;
    $("#hambBtn")?.addEventListener("click", () => { nav.classList.add("open"); document.body.style.overflow = "hidden"; });
    $("#mobileClose")?.addEventListener("click", () => { nav.classList.remove("open"); document.body.style.overflow = ""; });
    $$("#mobileNav > ul a").forEach((a) => a.addEventListener("click", () => { nav.classList.remove("open"); document.body.style.overflow = ""; }));
  }

  /* ---------------- Retour en haut ---------------- */
  function initBackTop() {
    const bt = $("#backTop");
    if (!bt) return;
    window.addEventListener("scroll", () => bt.classList.toggle("show", window.scrollY > 400));
    bt.addEventListener("click", () => window.scrollTo({ top: 0, behavior: "smooth" }));
  }

  /* ---------------- Panier — AJAX Cart API Shopify ---------------- */
  function moneyFormat(cents) {
    if (window.Shopify && window.Shopify.formatMoney && window.themeMoneyFormat) {
      return window.Shopify.formatMoney(cents, window.themeMoneyFormat);
    }
    return (cents / 100).toFixed(2) + " €";
  }

  function refreshCartBadge(count) {
    $$(".cart-badge").forEach((b) => { b.textContent = count; });
  }

  function fetchCart() {
    return fetch("/cart.js").then((r) => r.json());
  }

  function renderCartDrawer(cart) {
    const items = $("[data-cart-items]");
    const foot = $("[data-cart-foot]");
    if (!items || !foot) return;
    refreshCartBadge(cart.item_count);

    if (!cart.item_count) {
      items.innerHTML = `<div class="cart-empty">
        <svg viewBox="0 0 24 24"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
        <p data-t="cart.empty"></p>
      </div>`;
      applyTranslations(items);
      foot.innerHTML = `<a href="/collections/all" class="btn-full" data-t="cart.continue"></a>`;
      applyTranslations(foot);
      return;
    }

    items.innerHTML = cart.items.map((line) => `
      <div class="cart-line" data-line-key="${line.key}">
        <a href="${line.url}"><img src="${line.image}" alt="${line.product_title}" width="76" height="96"></a>
        <div class="cart-line-info">
          <a href="${line.url}" class="cart-line-name">${line.product_title}</a>
          <span class="cart-line-variant">${line.variant_title || ""}</span>
          <div class="cart-line-bottom">
            <div class="qte-stepper">
              <button type="button" data-qty-change="-1" data-key="${line.key}" data-current="${line.quantity}">−</button>
              <span>${line.quantity}</span>
              <button type="button" data-qty-change="1" data-key="${line.key}" data-current="${line.quantity}">+</button>
            </div>
            <span class="cart-line-prix">${moneyFormat(line.final_line_price)}</span>
          </div>
        </div>
        <button class="cart-line-suppr" data-remove-line="${line.key}" aria-label="Retirer">
          <svg viewBox="0 0 24 24"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/></svg>
        </button>
      </div>`).join("");

    foot.innerHTML = `
      <div class="cart-subtotal"><span data-t="cart.subtotal"></span><strong>${moneyFormat(cart.total_price)}</strong></div>
      <p class="cart-note" data-t="cart.note"></p>
      <a href="/cart" class="btn-full-outline" data-t="cart.viewcart"></a>
      <a href="/checkout" class="btn-full" data-t="cart.checkout" style="margin-top:10px"></a>`;
    applyTranslations(foot);
  }

  function applyTranslations(root) {
    if (!window.themeTranslations) return;
    $$("[data-t]", root).forEach((el) => {
      const key = el.getAttribute("data-t");
      if (window.themeTranslations[key]) el.textContent = window.themeTranslations[key];
    });
  }

  function openCartDrawer() {
    $("[data-overlay-cart]")?.classList.add("visible");
    $("[data-cart-drawer]")?.classList.add("open");
    document.body.style.overflow = "hidden";
    fetchCart().then(renderCartDrawer);
  }
  function closeCartDrawer() {
    $("[data-overlay-cart]")?.classList.remove("visible");
    $("[data-cart-drawer]")?.classList.remove("open");
    document.body.style.overflow = "";
  }

  function initCartDrawer() {
    $(".cart-icon")?.addEventListener("click", (e) => { e.preventDefault(); openCartDrawer(); });
    $("[data-close-cart]")?.addEventListener("click", closeCartDrawer);
    $("[data-overlay-cart]")?.addEventListener("click", (e) => { if (e.target === e.currentTarget) closeCartDrawer(); });
    document.addEventListener("keydown", (e) => { if (e.key === "Escape") closeCartDrawer(); });

    document.body.addEventListener("click", (e) => {
      const qtyBtn = e.target.closest("[data-qty-change]");
      if (qtyBtn) {
        const delta = parseInt(qtyBtn.getAttribute("data-qty-change"), 10);
        const current = parseInt(qtyBtn.getAttribute("data-current"), 10);
        const key = qtyBtn.getAttribute("data-key");
        updateLine(key, Math.max(0, current + delta));
      }
      const removeBtn = e.target.closest("[data-remove-line]");
      if (removeBtn) updateLine(removeBtn.getAttribute("data-remove-line"), 0);

      const quickAdd = e.target.closest("[data-quick-add]");
      if (quickAdd) {
        e.preventDefault();
        const variantId = quickAdd.getAttribute("data-quick-add");
        const fd = new FormData();
        fd.append("id", variantId);
        fd.append("quantity", 1);
        addToCart(fd, null);
      }
    });

    // Ajout au panier depuis les fiches produit (formulaires product-form) et les boutons "Ajout rapide"
    document.body.addEventListener("submit", (e) => {
      const form = e.target.closest("form[data-product-form]");
      if (!form) return;
      e.preventDefault();
      addToCart(new FormData(form), form);
    });

    // Rafraîchit le badge panier au chargement de chaque page
    fetchCart().then((cart) => refreshCartBadge(cart.item_count));
  }

  function updateLine(key, quantity) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity }),
    }).then((r) => r.json()).then(renderCartDrawer);
  }

  function addToCart(formData, form) {
    const errorEl = form ? form.querySelector("[data-form-error]") : null;
    if (errorEl) errorEl.textContent = "";
    fetch("/cart/add.js", { method: "POST", body: formData })
      .then((r) => r.json())
      .then((data) => {
        if (data.status) {
          if (errorEl) errorEl.textContent = data.description || data.message;
          return;
        }
        openCartDrawer();
      })
      .catch(() => { if (errorEl) errorEl.textContent = "Une erreur est survenue."; });
  }

  /* ---------------- Guide des tailles (popup) ---------------- */
  function initSizeGuideModal() {
    const overlay = $("[data-overlay-sizeguide]");
    if (!overlay) return;
    const open = () => { overlay.classList.add("visible"); document.body.style.overflow = "hidden"; };
    const close = () => { overlay.classList.remove("visible"); document.body.style.overflow = ""; };
    $$("[data-open-sizeguide]").forEach((btn) => btn.addEventListener("click", (e) => { e.preventDefault(); open(); }));
    $("[data-close-sizeguide]")?.addEventListener("click", close);
    overlay.addEventListener("click", (e) => { if (e.target === overlay) close(); });
    document.addEventListener("keydown", (e) => { if (e.key === "Escape") close(); });
  }

  /* ---------------- Bascule cm / pouces (guide des tailles) ---------------- */
  function initUnitToggles() {
    $$("[data-unit-toggle]").forEach((toggle) => {
      toggle.addEventListener("click", (e) => {
        const btn = e.target.closest("[data-unit]");
        if (!btn) return;
        const unit = btn.getAttribute("data-unit");
        $$(".unit-toggle-btn", toggle).forEach((b) => b.classList.toggle("actif", b === btn));
        const scope = toggle.closest("[data-sizeguide-scope]") || document;
        $$("[data-unit-table]", scope).forEach((t) => { t.style.display = t.getAttribute("data-unit-table") === unit ? "" : "none"; });
      });
    });
  }

  /* ---------------- Liste de souhaits (localStorage + tiroir) ---------------- */
  const WISHLIST_KEY = "lovea-wishlist";
  const LEGACY_WISHLIST_KEYS = ["lovea-wishlist-v2", "lovea-wishlist-items", "lovea-wishlist-handles", "wishlist"];

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || "[]"); } catch (e) { return []; }
  }
  function setWishlist(list) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (e) {}
    $$(".wishlist-badge").forEach((b) => { b.textContent = list.length; b.style.display = list.length ? "flex" : "none"; });
    syncWishlistButtons(list);
    renderWishlistDrawer();
  }

  // Réconcilie les anciennes clés de stockage : lit toutes les clés observées,
  // fusionne en une seule liste (dédupliquée), écrit la clé canonique et supprime les doublons.
  function normalizeWishlistStorage() {
    let merged = [];
    const pushItem = (item) => {
      if (typeof item === "string" && item.trim()) {
        const h = item.trim();
        if (!merged.includes(h)) merged.push(h);
      } else if (item && typeof item === "object") {
        const h = item.handle || item.href || item.url;
        if (typeof h === "string" && h.trim()) {
          const handle = h.split("/").filter(Boolean).pop() || h.trim();
          if (!merged.includes(handle)) merged.push(handle);
        } else if (typeof item.id === "string" && !/^\d+$/.test(item.id)) {
          if (!merged.includes(item.id)) merged.push(item.id);
        }
      }
    };
    LEGACY_WISHLIST_KEYS.forEach((key) => {
      try {
        const raw = localStorage.getItem(key);
        if (!raw) return;
        const val = JSON.parse(raw);
        if (Array.isArray(val)) val.forEach(pushItem);
        else if (val && typeof val === "object") Object.values(val).forEach(pushItem);
      } catch (e) { /* ignore malformed legacy data */ }
    });
    try {
      const raw = localStorage.getItem(WISHLIST_KEY);
      if (raw) {
        const val = JSON.parse(raw);
        if (Array.isArray(val)) val.forEach(pushItem);
      }
    } catch (e) { /* ignore malformed canonical data */ }
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(merged)); } catch (e) {}
    LEGACY_WISHLIST_KEYS.forEach((key) => { try { localStorage.removeItem(key); } catch (e) {} });
    return merged;
  }

  function syncWishlistButtons(list) {
    $$("[data-wishlist-toggle]").forEach((btn) => {
      const handle = btn.getAttribute("data-wishlist-toggle");
      if (!handle) return;
      if (!btn.dataset.wishlistLabel) btn.dataset.wishlistLabel = btn.getAttribute("aria-label") || "";
      const active = list.includes(handle);
      btn.classList.toggle("on", active);
      btn.setAttribute("aria-label", active ? "Retirer des favoris" : btn.dataset.wishlistLabel);
    });
  }

  function initWishlist() {
    normalizeWishlistStorage();
    setWishlist(getWishlist());
    bindWishlistButtons();
    renderWishlistPage();
  }

  function bindWishlistButtons() {
    $$("[data-wishlist-toggle]").forEach((btn) => {
      if (btn.dataset.wishlistBound) return;
      btn.dataset.wishlistBound = "1";
      const handle = btn.getAttribute("data-wishlist-toggle");
      btn.classList.toggle("on", getWishlist().includes(handle));
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        let list = getWishlist();
        if (list.includes(handle)) { list = list.filter((x) => x !== handle); btn.classList.remove("on"); }
        else { list.push(handle); btn.classList.add("on"); }
        setWishlist(list);
      });
    });
  }

  function renderWishlistPage() {
    const container = $("[data-wishlist-page]");
    if (!container) return;
    const handles = getWishlist();
    if (!handles.length) {
      container.innerHTML = `<div class="empty-state">
        <svg viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
        <h2 data-t="wishlist.empty_title"></h2>
        <p data-t="wishlist.empty_text"></p>
      </div>`;
      applyTranslations(container);
      return;
    }
    Promise.all(handles.map((h) => fetch("/products/" + h + ".js").then((r) => (r.ok ? r.json() : null)).catch(() => null)))
      .then((products) => {
        const valid = products.filter(Boolean);
        if (!valid.length) { container.innerHTML = ""; return; }
        container.innerHTML = `<div class="products-grid">${valid.map(renderWishlistCard).join("")}</div>`;
        bindWishlistButtons();
      });
  }

  function renderWishlistCard(product) {
    const v = product.variants[0];
    const img1 = product.images[0] || product.featured_image;
    const img2 = product.images[1] || img1;
    return `<div class="prod-card">
      <a class="prod-img-wrap" href="${product.url}">
        <img class="prod-img-front" src="${img1}" alt="${product.title}">
        <img class="prod-img-back" src="${img2}" alt="${product.title}">
        <button type="button" class="wishlist-btn on" data-wishlist-toggle="${product.handle}">
          <svg viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
        </button>
      </a>
      <a href="${product.url}" class="prod-name-link"><p class="prod-name">${product.title}</p></a>
      <div class="prod-price-row"><span class="prod-price">${moneyFormat(v.price)}</span></div>
    </div>`;
  }

  /* ---------------- Tiroir liste de souhaits ---------------- */
  function openWishlistDrawer() {
    $("[data-overlay-wishlist]")?.classList.add("visible");
    $("[data-wishlist-drawer]")?.classList.add("open");
    document.body.style.overflow = "hidden";
    renderWishlistDrawer();
  }
  function closeWishlistDrawer() {
    $("[data-overlay-wishlist]")?.classList.remove("visible");
    $("[data-wishlist-drawer]")?.classList.remove("open");
    document.body.style.overflow = "";
  }

  function renderWishlistDrawer() {
    const drawer = $("[data-wishlist-drawer]");
    if (!drawer) return;
    const items = $("[data-wishlist-items]", drawer);
    const foot = $("[data-wishlist-foot]", drawer);
    const handles = getWishlist();

    if (!handles.length) {
      if (items) {
        items.innerHTML = `<div class="wishlist-empty">
          <svg viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
          <p data-t="wishlist.empty_title"></p>
          <span data-t="wishlist.empty_text"></span>
        </div>`;
        applyTranslations(items);
      }
      if (foot) {
        foot.innerHTML = `<a href="/collections/all" class="btn-full">Découvrir la collection</a>`;
      }
      return;
    }

    if (items) items.innerHTML = `<p class="wishlist-loading">Chargement…</p>`;

    Promise.all(handles.map((h) => fetch("/products/" + h + ".js").then((r) => (r.ok ? r.json() : null)).catch(() => null)))
      .then((products) => {
        const valid = products.filter(Boolean);
        if (!items || !foot) return;
        if (!valid.length) {
          items.innerHTML = `<div class="wishlist-empty"><p>Votre liste est vide.</p></div>`;
          foot.innerHTML = `<a href="/collections/all" class="btn-full">Découvrir la collection</a>`;
          return;
        }
        items.innerHTML = valid.map((product) => {
          const v = product.variants[0];
          const img = product.images[0] || product.featured_image;
          return `<div class="wishlist-line">
            <a href="${product.url}" class="wishlist-line-media"><img src="${img}" alt="${product.title}" width="76" height="96" loading="lazy"></a>
            <div class="wishlist-line-info">
              <a href="${product.url}" class="wishlist-line-name">${product.title}</a>
              <span class="wishlist-line-price">${moneyFormat(v.price)}</span>
            </div>
            <button type="button" class="wishlist-line-remove" data-wishlist-remove="${product.handle}" aria-label="Retirer des favoris">
              <svg viewBox="0 0 24 24"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/></svg>
            </button>
          </div>`;
        }).join("");
        foot.innerHTML = `<a href="/pages/wishlist" class="btn-full-outline">Voir la liste complète</a>`;
      });
  }

  function initWishlistDrawer() {
    const drawer = $("[data-wishlist-drawer]");
    if (!drawer) return;
    $$("[data-wishlist-drawer-toggle]").forEach((btn) => btn.addEventListener("click", (e) => { e.preventDefault(); openWishlistDrawer(); }));
    $("[data-close-wishlist]")?.addEventListener("click", closeWishlistDrawer);
    $("[data-overlay-wishlist]")?.addEventListener("click", (e) => { if (e.target === e.currentTarget) closeWishlistDrawer(); });
    document.addEventListener("keydown", (e) => { if (e.key === "Escape") closeWishlistDrawer(); });

    document.body.addEventListener("click", (e) => {
      const removeBtn = e.target.closest("[data-wishlist-remove]");
      if (removeBtn) {
        const handle = removeBtn.getAttribute("data-wishlist-remove");
        setWishlist(getWishlist().filter((x) => x !== handle));
      }
    });
  }

  /* ---------------- Pastilles couleur sur les cartes produit ---------------- */
  function initCardColorSwatches() {
    document.body.addEventListener("click", (e) => {
      const swatch = e.target.closest("[data-card-color]");
      if (!swatch) return;
      e.preventDefault();
      const card = swatch.closest(".prod-card");
      if (!card) return;
      const raw = card.getAttribute("data-color-map");
      if (!raw) return;
      let map;
      try { map = JSON.parse(raw); } catch (err) { return; }
      const value = swatch.getAttribute("data-color-value");
      const entry = map[value];
      if (!entry) return;

      const frontImg = $(".prod-img-front", card);
      if (frontImg && entry.image) frontImg.src = entry.image;

      const priceRow = $(".prod-price-row", card);
      if (priceRow && entry.price) {
        let html = `<span class="prod-price">${moneyFormat(entry.price)}</span>`;
        if (entry.compare && entry.compare > entry.price) {
          html += `<span class="prod-price-orig">${moneyFormat(entry.compare)}</span>`;
        }
        priceRow.innerHTML = html;
      }

      $$("[data-card-color]", card).forEach((b) => {
        const active = b === swatch;
        b.classList.toggle("actif", active);
        b.setAttribute("aria-pressed", active ? "true" : "false");
      });
    });
  }

  /* ---------------- Carrousel vidéos (avis en vidéo, contenu démo) ---------------- */
  function initVideoCarousel() {
    const track = $("[data-video-track]");
    if (!track) return;

    $$("[data-video-card]", track).forEach((card) => {
      const video = $("video", card);
      card.addEventListener("click", (e) => {
        if (e.target.closest("[data-video-mute]")) {
          video.muted = !video.muted;
          $("[data-video-mute]", card).innerHTML = video.muted ? '<svg viewBox="0 0 24 24"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>' : '<svg viewBox="0 0 24 24"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M15.5 8.5a5 5 0 0 1 0 7"/></svg>';
          return;
        }
        if (video.paused) {
          $$("[data-video-card] video", track).forEach((v) => { if (v !== video) { v.pause(); v.closest(".video-card").classList.remove("playing"); } });
          video.play();
          card.classList.add("playing");
        } else {
          video.pause();
          card.classList.remove("playing");
        }
      });
    });

    $("[data-video-prev]")?.addEventListener("click", () => track.scrollBy({ left: -260, behavior: "smooth" }));
    $("[data-video-next]")?.addEventListener("click", () => track.scrollBy({ left: 260, behavior: "smooth" }));
  }

  /* ---------------- Recherche (overlay + recherche prédictive native Shopify) ---------------- */
  function initSearchOverlay() {
    const overlay = $("[data-overlay-search]");
    if (!overlay) return;
    const open = () => { overlay.classList.add("visible"); document.body.style.overflow = "hidden"; setTimeout(() => $("[data-search-input]")?.focus(), 60); };
    const close = () => { overlay.classList.remove("visible"); document.body.style.overflow = ""; };
    $(".search-icon")?.addEventListener("click", (e) => { e.preventDefault(); open(); });
    $("[data-close-search]")?.addEventListener("click", close);
    overlay.addEventListener("click", (e) => { if (e.target === overlay) close(); });
    document.addEventListener("keydown", (e) => { if (e.key === "Escape") close(); });
  }

  /* ---------------- Accordéon FAQ ---------------- */
  function initAccordions() {
    $$(".accordion-head").forEach((btn) => {
      btn.addEventListener("click", () => {
        const item = btn.closest(".accordion-item");
        const wasOpen = item.classList.contains("open");
        item.parentElement.querySelectorAll(".accordion-item.open").forEach((i) => i.classList.remove("open"));
        if (!wasOpen) item.classList.add("open");
      });
    });
  }

  /* ---------------- Newsletter (formulaire client Shopify natif) ---------------- */
  function initNewsletterForm() {
    $$("form[data-newsletter-form]").forEach((form) => {
      form.addEventListener("submit", () => {
        // Le formulaire soumet nativement vers Shopify (customer form) ; le message de succès
        // s'affiche via ?customer_posted=true, géré côté section newsletter.liquid.
      });
    });
  }

  /* ---------------- Page produit : galerie + variantes ---------------- */
  function initProductForm() {
    $$("[data-product-root]").forEach((root) => {
      const thumbs = $$("[data-pd-thumb]", root);
      const mainImg = $("[data-pd-main-img]", root);
      thumbs.forEach((btn) => {
        btn.addEventListener("click", () => {
          thumbs.forEach((b) => b.classList.remove("actif"));
          btn.classList.add("actif");
          if (mainImg) mainImg.src = btn.getAttribute("data-full-src");
        });
      });

      const qtyMinus = $("[data-pd-qte-moins]", root);
      const qtyPlus = $("[data-pd-qte-plus]", root);
      const qtyInput = $("[data-pd-qte-input]", root);
      qtyMinus?.addEventListener("click", () => { qtyInput.value = Math.max(1, parseInt(qtyInput.value || 1, 10) - 1); });
      qtyPlus?.addEventListener("click", () => { qtyInput.value = parseInt(qtyInput.value || 1, 10) + 1; });

      initVariantPicker(root);
    });
  }

  /* ---------------- Sélection des variantes (couleur / taille) ---------------- */
  function initVariantPicker(root) {
    const jsonEl = $("[data-product-json]", root.parentElement) || $("[data-product-json]");
    if (!jsonEl) return;
    let variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    const optionButtons = $$("[data-pd-option-select]", root);
    if (!optionButtons.length) return;

    // état courant : { "1": "Noir", "2": "M" } (position d'option -> valeur choisie)
    const selected = {};
    optionButtons.forEach((btn) => {
      if (btn.classList.contains("actif")) selected[btn.getAttribute("data-option-position")] = btn.getAttribute("data-option-value");
    });

    function findVariant() {
      return variants.find((v) => {
        return Object.keys(selected).every((pos) => v.options[parseInt(pos, 10) - 1] === selected[pos]);
      });
    }

    function updateUI() {
      const variant = findVariant();
      const priceEl = $("[data-pd-price]", root);
      const compareEl = $("[data-pd-compare]", root);
      const discountEl = $("[data-pd-discount]", root);
      const variantInput = $("[data-pd-variant-id]", root);
      const addBtn = $("[data-pd-add]", root);
      const addLabel = $("[data-pd-add-label]", root);
      const colorLabel = $("[data-pd-color-label]", root);

      if (!variant) {
        if (addBtn) addBtn.setAttribute("disabled", "");
        if (addLabel) addLabel.textContent = window.themeTranslations ? window.themeTranslations["product.unavailable"] : "Indisponible";
        return;
      }

      if (variantInput) variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = moneyFormat(variant.price);
      if (variant.compare_at_price > variant.price) {
        if (compareEl) { compareEl.style.display = ""; compareEl.textContent = moneyFormat(variant.compare_at_price); }
        if (discountEl) {
          const pct = Math.round(100 - (variant.price / variant.compare_at_price) * 100);
          discountEl.style.display = "";
          discountEl.textContent = "−" + pct + "%";
        }
      } else {
        if (compareEl) compareEl.style.display = "none";
        if (discountEl) discountEl.style.display = "none";
      }
      if (colorLabel && selected["1"]) colorLabel.textContent = selected["1"];

      if (addBtn) {
        if (variant.available) { addBtn.removeAttribute("disabled"); }
        else { addBtn.setAttribute("disabled", ""); }
      }
      if (addLabel && window.themeTranslations) {
        addLabel.textContent = variant.available ? window.themeTranslations["product.add_to_cart"] : window.themeTranslations["product.sold_out"];
      }

      if (variant.featured_image && mainImgFor(root)) {
        const sep = variant.featured_image.src.indexOf("?") > -1 ? "&" : "?";
        mainImgFor(root).src = variant.featured_image.src + sep + "width=900";
      }
    }

    function mainImgFor(scope) { return $("[data-pd-main-img]", scope); }

    optionButtons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const pos = btn.getAttribute("data-option-position");
        $$('[data-option-position="' + pos + '"]', root).forEach((b) => b.classList.remove("actif"));
        btn.classList.add("actif");
        $$('[data-option-position="' + pos + '"]', root).forEach((b) => b.setAttribute("aria-pressed", b === btn ? "true" : "false"));
        selected[pos] = btn.getAttribute("data-option-value");
        updateUI();
      });
    });

    updateUI();
  }
})();
